export function removeLicensePlateSeparators(licensePlate) {
  return String(licensePlate).replace(/\s|-/g, '');
}